export default {
  nav: {
    services: 'Services',
    process: 'How it works',
    why: 'Why Kettelsen',
    book: 'Book a call'
  },
  hero: {
    eyebrow: 'Nearshore recruiting · Powered by the Kettelsen group',
    title: 'Elite talent from Mexico, hired and ready to work for you',
    subtitle: 'Kettelsen finds, vets, and relocates the professionals your U.S. company needs — managing recruiting, immigration, and onboarding from start to finish. Talent knows no borders.',
    primaryCta: 'Book a call',
    secondaryCta: 'See how it works',
    tagline: 'Inspiring mobility, driving growth.'
  },
  trust: {
    items: [
      {
        title: 'Vetted, specialized talent',
        desc: 'We identify highly qualified professionals in technology, engineering, medicine and more — screened for both skills and culture fit.'
      },
      {
        title: 'End to end, handled',
        desc: 'From sourcing to visas to relocation, we manage the entire hiring and immigration process so you don’t have to.'
      },
      {
        title: 'Compliant and fast',
        desc: 'Deep expertise in international recruiting and immigration means a smooth, low-risk transition for talent and employer alike.'
      }
    ]
  },
  services: {
    eyebrow: 'What we do',
    title: 'One partner for the entire journey',
    subtitle: 'We are your single, integrated solution — managing every hiring and immigration need from beginning to end.',
    items: [
      {
        title: 'Talent sourcing',
        desc: 'We tap a deep pool of specialized professionals across Mexico and the world, matched precisely to your requirements.'
      },
      {
        title: 'Recruiting & selection',
        desc: 'Proven screening and interviewing to surface candidates who fit your role, your team, and your goals.'
      },
      {
        title: 'Immigration & visas',
        desc: 'We manage the full visa and immigration process, removing the administrative and legal barriers to relocation.'
      },
      {
        title: 'Relocation & integration',
        desc: 'Cultural adaptation and onboarding support so your new hires integrate seamlessly and start delivering quickly.'
      }
    ]
  },
  process: {
    eyebrow: 'How it works',
    title: 'From need to new hire, in four steps',
    subtitle: 'A clear, agile process designed to get the right people on your team faster.',
    steps: [
      {
        title: 'Tell us what you need',
        desc: 'We start by understanding your roles, required skills, and goals in a short discovery call.'
      },
      {
        title: 'We source & vet',
        desc: 'We identify and screen qualified candidates, then present you a shortlist of the strongest fits.'
      },
      {
        title: 'We handle hiring & immigration',
        desc: 'Offers, contracts, visas, and immigration — managed end to end on your behalf.'
      },
      {
        title: 'Talent integrated',
        desc: 'We support relocation and onboarding so your new team members ramp up smoothly.'
      }
    ]
  },
  why: {
    eyebrow: 'Why Kettelsen',
    title: 'A smarter way to grow your team',
    subtitle: 'Nearshore talent gives U.S. companies the reach of global hiring with the ease of working close to home.',
    points: [
      'Access to specialized talent in technology, engineering, medicine, and beyond.',
      'Time-zone alignment for real-time collaboration with your U.S. teams.',
      'Bilingual professionals ready to integrate with your company culture.',
      'A faster, more cost-effective hiring process — without cutting corners.',
      'One accountable partner for recruiting, immigration, and onboarding.'
    ],
    stats: [
      { value: '500+', label: 'Professionals placed' },
      { value: '98%', label: 'Client retention' },
      { value: '30+', label: 'Industries served' },
      { value: '4 wks', label: 'Avg. time to shortlist' }
    ],
    statsNote: '* Placeholder figures — to be confirmed with the Kettelsen team.'
  },
  booking: {
    eyebrow: 'Let’s talk',
    title: 'Book a call with our team',
    subtitle: 'Pick a time that works for you. We’ll learn about your hiring needs and show you how Kettelsen can help.',
    fallbackText: 'Trouble loading the scheduler?',
    fallbackCta: 'Open the booking page'
  },
  footer: {
    tagline: 'International recruiting that connects global talent with opportunity in the United States.',
    exploreTitle: 'Explore',
    servicesTitle: 'Services',
    contactTitle: 'Contact',
    group: 'Part of the Kettelsen group. Legal & HR in Mexico by Esquerra Jurídico.',
    rights: 'All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    contact: {
      address: 'San Luis Potosí, México',
      phone: '+52 444 000 0000',
      email: 'contacto@kettelsenmexico.com'
    }
  }
}
